// @ts-nocheck
import React from 'react';
import axios from "axios";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import Typography from "@mui/material/Typography";
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import Divider from '@mui/material/Divider';
import SinapThemev2 from "../styles/SinapThemev2";
import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeProvider, StyledEngineProvider, styled } from '@mui/material/styles';
import BuscadorPorIniciales from "./Componentes/BuscadorPorIniciales";
import { useUsuarios } from "./State/UsuarioContext";
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { PersonaIconPrimary } from "./Componentes/AltaDeUsuario";
import { ModalDetallesUsuario } from "./Componentes/ModalDetallesUsuario";
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import LockResetIcon from '@mui/icons-material/LockReset';
import { ModalGeneral } from '../Componentes/ModalGeneral';
import ModalForzarPassword from "./Componentes/ModalForzarPassword";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ModalAcciones from "./Componentes/ModalAcciones";
import ModalVerPerfil from "./Componentes/ModalVerPerfil";
import { useAuth } from "../Auth/State/AuthContext";
import ModalAliasDeUsuario from "./Componentes/ModalAliasDeUsuario";
import { MaterialReactTable, MRT_ActionMenuItem, useMaterialReactTable } from "material-react-table";
import { Delete } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { Edit as EditIcon } from '@mui/icons-material';
import DeleteIcon from "@mui/icons-material/Delete";
import Tabla from "../Componentes/Tabla";
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function GestionarUsuario({ ...props }) {
    const columns = React.useMemo(
        () => [
            {
                accessorKey: 'nombre',
                header: 'Nombre',
                size: 150,
            },
            {
                accessorKey: 'apellido',
                header: 'Apellido',
                size: 150,
            },
            {
                accessorKey: 'frbaEmail',
                header: 'Email',
                size: 200,
            }

        ],
        [],
    );
    const responsiveColumns = React.useMemo(
        () => [

            {
                accessorKey: 'frbaEmail',
                header: 'Email',
                size: 130,
                Cell: ({ cell }) => (
                    <span style={{
                        display: 'block',
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '200px'
                    }}>
                        {cell.getValue()}
                    </span>
                ),
            }

        ],
        [],
    );
    const matches = useMediaQuery('(min-width:1185px)');
    const { getUsuarios, usuarios, fetchUsuarioBuscado, usuario } = useUsuarios();
    const [openModalVer, setOpenModalVer] = React.useState(null);
    const [openModalAcciones, setModalAcciones] = React.useState(null);
    const [openModalVerPerfil, setOpenModalVerPerfil] = React.useState(false);
    const [openModalHabilitar, setOpenModalHabilitar] = React.useState(null);
    const [openModalForzar, setOpenModalForzar] = React.useState(null);
    const [openModalAlias, setOpenModalAlias] = React.useState(null);
    const [userUid, setUserUid] = React.useState();
    const { user, hasRole } = useAuth();

    React.useEffect(() => {
        getUsuarios()
    }, [])

    const abrirModalVerPerfil = (uidUsuario) => {
        setOpenModalVerPerfil(true)
        fetchUsuarioBuscado(uidUsuario)
    }

    const abrirModalAcciones = (uidUsuario) => {
        setModalAcciones(true)
        fetchUsuarioBuscado(uidUsuario)
    }

    const abrirModalVer = (uidUsuario) => {
        setOpenModalVer(true)
        setUserUid(uidUsuario)
    }

    return (
        <Box>
            {openModalAcciones && (
                <ModalAcciones prev={usuario}
                    setOpenModalForzar={(value) => setOpenModalForzar(value)}
                    setOpenModalVer={(value) => setOpenModalVer(value)}
                    setOpenModalHabilitar={(value) => setOpenModalHabilitar(value)}
                    setOpenModalAlias={(value) => setOpenModalAlias(value)}
                    open={openModalAcciones}
                    onClose={() => setModalAcciones(false)}
                />
            )}
            {openModalVerPerfil && (
                <ModalGeneral
                    Contenido={<ModalVerPerfil userUid={userUid} />}
                    open={openModalVerPerfil}
                    onClose={() => setOpenModalVerPerfil(false)}
                    titulo={"Datos del Usuario"}
                />
            )}
            {openModalVer && (
                <ModalDetallesUsuario actualizarTabla={() => getUsuarios()} actualizarInfoPrev={() => fetchUsuarioBuscado(usuario.uid)} prev={usuario} open={openModalVer} onClose={() => setOpenModalVer(false)} />
            )}
            {openModalForzar && (
                <ModalForzarPassword prev={usuario} open={openModalForzar} onClose={() => setOpenModalForzar(false)} />
            )}
            {openModalAlias && (
                <ModalAliasDeUsuario prev={usuario} open={openModalAlias} onClose={() => setOpenModalAlias(false)} />
            )}

            <Typography
                my={"40px"}
                mx="10px"
                fontSize={matches ? "30px" : "28px"}
            >
                Gestionar Usuarios
            </Typography>
            <Box width="100%" px={matches ? 0 : 2} mb={2}>
                <BuscadorPorIniciales />
            </Box>
            <Tabla
                columns={matches ? columns : responsiveColumns}
                enableColumnResizing={matches ? false : true}
                enableFullScreenToggle={false}
                layoutMode='grid'
                getRowId={(row) => row.uid}
                data={usuarios}
                enableRowActions
                positionActionsColumn='last'
                renderRowActions={({ row, table }) => (
                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                        <IconButton
                            color="secondary"
                            onClick={() => {
                                abrirModalVerPerfil(row.id);
                            }}
                        >
                            <VisibilityIcon />
                        </IconButton>
                        {hasRole(["ROLE_SOPORTE"]) && (
                            <IconButton
                                color="secondary"
                                onClick={() => {
                                    abrirModalAcciones(row.id);
                                }}
                            >
                                <ManageAccountsIcon />
                            </IconButton>
                        )}
                    </Box>
                )}
            />
        </Box>
    );
}